module.exports = __webpack_public_path__ + "img/slider4.d6fab9f9.gif";